<template>
    <div class="d-flex flex-columns">
        <v-autocomplete
            dense
            outlined
            v-bind="$attrs"
            :items="items"
            :filter="filter"
            chips
            deletable-chips
            small-chips
            item-text="category"
            item-value="id"
            multiple
            :value="value"
            v-on="$listeners"
        >
            <template #item="data">
                <v-list-item-content>
                    <v-list-item-title>{{ data.item.category }}</v-list-item-title>
                </v-list-item-content>
            </template>
        </v-autocomplete>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'CategoryMultiselect',

    props: {
        value: {
            type: Array,
            default: () => [],
        },
        forAddress: {
            type: Boolean,
            default: false,
        },
        forLocation: {
            type: Boolean,
            default: false,
        },
        forEventOrganizer: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            saving: false,
            showAddDlg: false,
            newTag: '',
            tagGroup: null,
        };
    },

    computed: {
        ...mapState('category', {
            loaded: 'loaded',
            collection: 'collection',
        }),

        items() {
            if (this.collection) {
                // Filter items by requested display scope (location/address etc).
                const items = this.collection.filter((item) => {
                    if (this.forAddress && item.for_address) {
                        return true;
                    }
                    if (this.forLocation && item.for_location) {
                        return true;
                    }
                    if (this.forEventOrganizer && item.for_event_organizer) {
                        return true;
                    }
                    return false;
                });
                return items.models;
            } else {
                return [];
            }
        },
    },

    mounted() {
        this.loadData();
    },

    methods: {
        ...mapActions('category', {
            loadData: 'load',
        }),
        filter(item, queryText) {
            let title = (item.category || '').toLowerCase();
            queryText = queryText.toLowerCase();
            return title.indexOf(queryText) >= 0;
        },
        reload() {
            this.loadData({ force: true });
        },
        remove(item) {
            this.$emit('input', this.value ? this.value.filter((i) => i !== item[this.itemValue]) : []);
        },
    },
};
</script>
